export function token(options) {
    const normalized = typeof options === 'string' ? { description: options } : options;
    const symbol = (normalized === null || normalized === void 0 ? void 0 : normalized.key)
        ? Symbol.for(normalized.key)
        : Symbol(normalized === null || normalized === void 0 ? void 0 : normalized.description);
    return { symbol };
}
export function optional(token, optionalValue) {
    return {
        symbol: token.symbol,
        isOptional: true,
        optionalValue,
    };
}
//# sourceMappingURL=tokens.js.map